export default __webpack_public_path__ + "static/media/1788.716fd054.png";